<template>
<div class="discover-container" v-if="isVisible">
    <div class="discover-section-container">
        <div id="genre-dropdown-container">
            <OrganizationDropdown :on-click-org="loadSongs" />
        </div>
        <div id="gold-picks-section" class="discover-header-container">
            <div class="title-text">Gold Picks</div>
            <div class="pagination-container"
                 v-if="goldPicks.length > goldPickPageSize"
            >
              <div
                  v-for="page in Math.ceil(goldPicks.length/goldPickPageSize)"
                  :key="page"
                  class="pagination-number"
                  :style="{ color: page === goldPickPageNumber ? '#e1a732' : '#fff' }"
                  @click="goldPickPageNumber = page"
              >
                {{ page }}
              </div>
            </div>
        </div>
        <div class="gold-pick-list" v-if="!isLoadingGoldPicks" ref="goldPickList">
            <div v-if="goldPicks.length === 0 && !isLoadingGoldPicks" class="no-songs">No Gold Picks</div>
            <GoldPick
                v-else
                v-for="(pick, index) in goldPicks.slice((goldPickPageNumber - 1) * goldPickPageSize, (goldPickPageNumber * goldPickPageSize))"
                :key="index"
                :song="pick"
                @click.native="onPressSong('goldPick', index + ((goldPickPageNumber - 1) * (goldPickPageSize)))"
                class="gold-pick-item"
                @mouseover="hovered = true"
                @mouseleave="hovered = false"
                :songPressed="currentSong.id === pick.id"
            />
        </div>
    </div>
    <div id="recent-uploads-section" class="discover-section-container">
        <div class="discover-header-container">
            <div class="title-text">Recent Uploads</div>
            <div class="pagination-container"
                 id="recent-uploads-pagination"
                 v-if="latestSongs.length > songPageSize"
            >
              <div
                  v-for="page in Math.ceil(latestSongs.length/songPageSize)"
                  :key="page"
                  class="pagination-number"
                  :style="{ color: page === songPageNumber ? '#e1a732' : '#fff' }"
                  @click="songPageNumber = page"
              >
                {{ page }}
              </div>
            </div>
        </div>
        <div class="no-songs" v-if="latestSongs.length === 0 && !organization && !isLoadingLatestSongs">No Songs</div>
        <div class="no-songs" v-if="latestSongs.length === 0 && organization && !isLoadingLatestSongs">No songs under that organization</div>
        <div class="recent-uploads-list" v-if="!isLoadingLatestSongs">
            <SongItem
                v-for="(song, index) in latestSongs.slice((songPageNumber - 1) * songPageSize, songPageNumber * songPageSize)"
                :key="index"
                :song="song"
                @click.native="onPressSong('latest', index + ((songPageNumber - 1) * (songPageSize)))"
                :songPressed="currentSong.id === song.id"
            />
        </div>
    </div>

</div>
</template>

<script>
import { db } from '@/config/firebaseInit'
import { environment } from '@/constants';
export default {
    name: 'Discover',
    components: {
        GoldPick: () => import('./GoldPick.vue'),
        SongItem: () => import ('./SongItem.vue'),
        OrganizationDropdown: () => import ('./OrganizationDropdown'),
    },
    props: {
        isVisible: {
            type: Boolean,
            default: true
        },
        getPressedSong: {
            type: Function
        },
        getLatestSongs: {
            type: Function
        },
        songPlaying: {
            type: Object
        }
    },
    data() {
        return {
            currentSong: '',
            organization: '',
            goldPicks: [],
            goldPickDisplay: 4,
            latestSongs: [],
            isLoadingGoldPicks: true,
            isLoadingLatestSongs: true,
            hovered: false,
            goldPickPageNumber: 1,
            goldPickPageSize: 4,
            songPageNumber: 1,
            songPageSize: 4,
        }
    },
    methods: {
        getGoldPicks(organization) {
          let goldPicks = [];
          let goldPickData;
          if (!organization || organization === 'All') {
            goldPickData =
                db.collection(`${environment}-submissions`)
                    .where('goldPick', '==', true)
                    .orderBy('uploadDate', 'desc');
          } else {
            goldPickData =
                db.collection(`${environment}-submissions`)
                    .where('goldPick', '==', true)
                    .where('organization', '==', organization)
                    .orderBy('uploadDate', 'desc');
          }
            goldPickData.get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const {
                        fileURL,
                        coverURL,
                        name,
                        attribution,
                        songName,
                        uploadDate,
                        likes,
                        organization
                    } = doc.data();
                    goldPicks.push({
                        artist: name,
                        songFile: fileURL,
                        img: coverURL,
                        title: songName,
                        id: doc.id,
                        uploadDate,
                        likes,
                        attribution,
                        organization
                    });
                })
            }).catch((error) => {
              console.log('could not get gold picks: ', error);
            });
            this.goldPicks = goldPicks;
            this.$nextTick(() => {
                this.isLoadingGoldPicks = false;
            })
        },
        getAllSongs(organization) {
          let allSongs = [];
            let songData;
            if (!organization || organization === 'All') {
                songData =
                  db.collection(`${environment}-submissions`)
                    .where('approved', '==', true)
                    .orderBy('uploadDate', 'desc');
            } else {
                songData =
                  db.collection(`${environment}-submissions`)
                    .where('approved', '==', true)
                    .where('organization', '==', organization)
                    .orderBy('uploadDate', 'desc');
            }
            songData.get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const {
                        fileURL,
                        coverURL,
                        name,
                        attribution,
                        songName,
                        uploadDate,
                        likes,
                        organization,
                    } = doc.data();
                    allSongs.push({
                        artist: name,
                        songFile: fileURL,
                        img: coverURL,
                        title: songName,
                        id: doc.id,
                        uploadDate,
                        likes,
                        attribution,
                        organization,
                    })
                });
            });
            this.latestSongs = allSongs;
            this.getLatestSongs(allSongs);
            this.$nextTick(() => {
                this.isLoadingLatestSongs = false;
            })
        },
        onPressSong(listType, index) {
            if (listType === 'goldPick') {
                this.currentSong = this.goldPicks[index];
            } else {
                this.currentSong = this.latestSongs[index];
            }
            this.getPressedSong(this.currentSong, index);
        },
        loadSongs (organization) {
          this.organization = organization;
          this.getAllSongs(organization);
          this.getGoldPicks(organization);
        }
    },
    watch: {
        songPlaying: function() {
            this.currentSong = this.songPlaying;
        }
    },
    created() {
        this.getGoldPicks();
        this.getAllSongs();
    },
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';
.discover-container {
    display: flex;
    flex-direction: column;
    background-color: black;
    padding-bottom: 200px;
    height: 100%;
}

.discover-section-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
}

.discover-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-number {
  font-family: Lato-Regular, sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 6px;
}

.title-text {
    color: white;
    font-size: 30px;
    font-family: SSNicksonFour, serif;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    margin: 30px 0 15px 0;
    width: 100%;
}

.gold-pick-list {
    display: flex;
    width: 100%;
    overflow-y: hidden;
    overflow-x: scroll;
    padding-left: 2%;
    padding-right: 5%;
    -ms-overflow-style: none;
}

.gold-pick-list::-webkit-scrollbar {
    display: none;
}

.gold-pick-item {
    margin: 5px;
}

.loading-gold-picks {
    display: flex;
    justify-content: space-evenly;
}

.gold-pick-loader {
    margin: 5px;
}

.recent-uploads-list {
    width: 100%;
}

#recent-uploads-section, #gold-picks-section {
    padding: 0 3%;
}

.no-songs {
    color: white;
    font-family: 'Lato-Regular', sans-serif;
    font-size: 16px;
}

#genre-dropdown-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 16px 3% 0 3%;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .gold-pick-list {
    overflow-y: hidden;
    overflow-x: scroll;
    -ms-overflow-style: none;
  }

  .gold-pick-list::-webkit-scrollbar {
    display: none;
  }

  .discover-container {
    padding-bottom: 80px;
  }

  .title-text {
    font-size: 17px;
    margin: 10px 0 15px 0;
  }

  #genre-dropdown-container {
    margin-top: 3%;
    margin-right: 0;
  }

  .no-songs {
    font-size: 12px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
    .gold-pick-list {
        flex-wrap: nowrap;
        padding: 0 2%;
    }
}
</style>
